import { render, staticRenderFns } from "./MotorComponent.vue?vue&type=template&id=52ab6f58&scoped=true&"
import script from "./MotorComponent.vue?vue&type=script&lang=js&"
export * from "./MotorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ab6f58",
  null
  
)

export default component.exports